import {
  createHistory,
  createTestHistory
} from '@daedalus/core/src/_web/utils/history/createHistory'

export default typeof window === 'undefined'
  ? createTestHistory()
  : createHistory()
